import { AppData } from '@wix/document-services-types';
import { EditorElementBuilder } from '@wix/component-protocol/builder';

import { AbstractComponentFlow } from './AbstractComponentFlow';
import {
  ManifestComponentExtensionType,
  ManifestStore,
  PanelStore,
} from '../stores';

export class SystemComponentFlow extends AbstractComponentFlow<ManifestStore> {
  static SYSTEM_APP_DEF_ID = '88110a9d-ba44-450e-bcf9-17058af00b76';
  /**
   * System components are components that are predefined in the store and do not require a manifest to be loaded.
   */
  public readonly type = ManifestComponentExtensionType.SYSTEM;
  private readonly systemComponentAppData: AppData =
    this.dm.platform.getAppDataByAppDefId(
      SystemComponentFlow.SYSTEM_APP_DEF_ID,
    )!;

  async loadManifest() {
    // Empty implementation for system components because manifests predefined in the store
  }

  async loadPanels() {
    // Empty implementation for system components because panels predefined in the store
  }

  getCompTypes(): string[] {
    // Empty implementation for system components because manifests predefined in the store
    return [];
  }

  async loadPanelsByCompType({ compType }: { compType: string }) {
    const manifest = this.manifestStore.getManifest(compType);

    if (!manifest || !manifest.editorElement) {
      return;
    }

    const panels = await this._loadPanels(
      manifest.editorElement,
      this.systemComponentAppData,
    );
    Object.keys(panels).forEach((actionName) => {
      this.panelStore.setPanel(compType, actionName, panels[actionName]);
    });

    const tree = this.manifestStructureService.getChildrenElementManifests(
      manifest.editorElement,
    );

    Object.keys(tree).map(async (innerPath) => {
      const editorElement = new EditorElementBuilder(
        manifest.editorElement,
      ).getElementByPath(innerPath)!;
      const _panels = await this._loadPanels(
        editorElement,
        this.systemComponentAppData,
      );

      Object.keys(_panels).forEach((actionName) => {
        this.panelStore.setPanel(
          PanelStore.getPanelId(compType, innerPath.split('.')),
          actionName,
          _panels[actionName],
        );
      });
    });
  }
}
